import Workspace from "./workspace";
import useWorkspaceMembership from "../workspace-membership/use-workspace-membership";
import api from "../../system/api";

export async function requestWorkspaceArchive(documentId, client = api) {
  if (!documentId) return null;
  return client.post(`/workspaces/${documentId}/archive`, {}, {
    headers: {workspace: documentId},
    suppressGlobalErrorHandler: true,
  });
}

export function useWorkspace() {
  const workspaceMembership = useWorkspaceMembership();

  const updateWorkspace = async (_documentId, _workspaceData)=>{
    const workspace = new Workspace();
    try {
      await workspace.updateItem(_documentId, _workspaceData);
      await workspaceMembership.getWorkspaceMemberships();
    }catch (e) {

    }
  }

  const createWorkspace = async (data, {refreshMemberships = true} = {}) => {
    const response = await api.post("/create-workspace", {data});
    if (refreshMemberships) await workspaceMembership.getWorkspaceMemberships();
    return response?.data?.data || null;
  };

  const archiveWorkspace = async (documentId) => {
    if (!documentId) return null;
    const response = await requestWorkspaceArchive(documentId);
    await workspaceMembership.getWorkspaceMemberships();
    return response?.data?.data || null;
  };

  return {updateWorkspace, createWorkspace, archiveWorkspace};
}
